export default __webpack_public_path__ + "static/media/screen-left-count.ea1c9f23.svg";